/**
 * Storefront — the root area's own "storefront" component, hosting a nested
 * "storefront" schmancy-area that today renders only "landing". The event
 * page ("/:eventId") and order-access ("order") are separate root-level
 * components the app's own root area swaps to directly, not routes nested
 * here — a "back to storefront" link (brand-bar.view.ts, event-header's
 * not-found frame) pushes `area: "root", component: "storefront"` to return.
 * A pure router — no header, no padding, no max-width; each route owns its
 * own chrome (the brand header is landing's, not the shell's).
 */
import { lazy } from "@mhmo91/schmancy";
import { fill, overflowWithin } from "@mhmo91/schmancy/directives";
import { SchmancyElement, schmancyElement } from "@mhmo91/schmancy/mixins";
import { html } from "lit";

/** The storefront area's one route name — a segment no organization id may take. */
export const STOREFRONT_LANDING = "landing";

@schmancyElement("storefront-view")
export default class Storefront extends SchmancyElement {
	override render() {
		return html`
			<schmancy-surface ${fill()} type="containerLowest" opacity="solid" class="flex flex-col">
				<schmancy-area
					${overflowWithin()}
					class="flex flex-col"
					name="storefront"
					.default=${lazy(() => import("./landing/landing.view.ts"))}
				>
					<schmancy-route when=${STOREFRONT_LANDING} .component=${lazy(() => import("./landing/landing.view.ts"))}></schmancy-route>
				</schmancy-area>
			</schmancy-surface>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"storefront-view": Storefront;
	}
}
